"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Phase = void 0;
var Phase;
(function (Phase) {
    Phase["ACTION"] = "action";
    Phase["END"] = "end";
    Phase["PRODUCTION"] = "production";
    Phase["RESEARCH"] = "research";
    Phase["INITIALDRAFTING"] = "initial_drafting";
    Phase["DRAFTING"] = "drafting";
    Phase["PRELUDES"] = "preludes";
    Phase["CEOS"] = "ceos";
    Phase["SOLAR"] = "solar";
    Phase["INTERGENERATION"] = "intergeneration";
})(Phase = exports.Phase || (exports.Phase = {}));
